import { useQueryClient } from '@tribeplatform/react-sdk/lib';
import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys/authToken.keys';
import { getNetworkKey } from '../../utils/keys/network.key';
export const useUpdateMemberSchemaField = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    return useMutation(input => client.network.updateMemberSchemaField(input, fields), {
        ...useMutationOptions,
        ...{
            onSettled: () => {
                queryClient.invalidateQueries(networkKey);
                queryClient.invalidateQueries(authTokenKey);
            },
        },
    });
};
//# sourceMappingURL=useUpdateMemberSchemaField.js.map